import { all, call, takeEvery, take, select } from 'redux-saga/effects'
import { eventChannel } from 'redux-saga'
import moment from 'moment-timezone'
// import { modityNotificationItem } from '../notifications/sagas'
import { convertTime /* notificationsSetState */ } from '../actions'

// YQ: need to create socket service
const socketServerURL = `wss://t2kpeb2tp2.execute-api.us-east-1.amazonaws.com/prod`
let socket

const getDashboard = (state) => state.dashboard
// const getNotification = (state) => state.notifications
const getClinic = (state) => state.clinic

const connectSocket = (jwtToken, clinicId) => {
  if (socket) {
    socket.close()
  }

  socket = new WebSocket(`${socketServerURL}?token=${jwtToken}&type=clinic`)
  return new Promise((resolve) => {
    socket.onopen = () => {
      socket.send(
        JSON.stringify({
          action: 'register_clinic',
          clinic_id: clinicId,
          room: 'Testing',
          content: 'Live graph web-scoket',
          device_type: 'Web',
          client_id: Math.random() * 1000000 + 1,
          device_id: 'b4e62ddefec1',
        }),
      )
      resolve(true)
    }
  })
}

const createSocketChannel = (socketInstance) =>
  eventChannel((emit) => {
    const handler = (data) => {
      emit(data)
    }
    socketInstance.onmessage = handler
    socketInstance.onerror = handler
    return () => {
      socketInstance.onclose = handler
    }
  })

export function* LISTEN_TO_DB_SOCKET({ payload }) {
  yield take
  const { jwtToken } = payload
  const { userClinic } = yield select(getClinic)
  yield call(connectSocket, jwtToken, userClinic.id)

  const socketChannel = yield call(createSocketChannel, socket)
  while (true) {
    const returnedData = yield take(socketChannel)
    let { data } = returnedData
    data = JSON.parse(data)

    // temporary disabled
    // if (data.action && data.action === 'rr_notification') {
    //   const { topBarNotifications, notificationsList } = yield select(getNotification)
    //   try {
    //     let { notification } = data
    //     notification = modityNotificationItem(notification)
    //     notificationsList.unshift(notification)
    //     topBarNotifications.unshift(notification)
    //     yield put(notificationsSetState({ notificationsList, topBarNotifications }))
    //   } catch (err) {
    //     window.log('notification socket error', err)
    //   }
    // }
    if (data.device_id && data.action !== 'rr_notification') {
      const { patientList } = yield select(getDashboard)
      patientList.map((value) => {
        if (value.device.device_id && value.device.device_id === data.device_id) {
          if (data.action === 'rr') {
            if (value.rr_last_mint && value.rr_last_mint.avg && !data.rr_last_mint.avg) {
              value.holdValue = true
              value.changeLabel = true
              value.lastUpdated = value.rr_last_mint.tracker_ts
              if (!value.cardFlashTimer) {
                value.cardFlashTimer = data.rr_last_mint.tracker_ts
              } else {
                const currentTimeConvert = convertTime(
                  moment().utc().format('YYYY-MM-DD HH:mm:ss'),
                  value.device.device_tz,
                  'YYYY-MM-DD HH:mm:ss',
                )
                const duration = moment.duration(
                  moment(currentTimeConvert).diff(
                    new Date(
                      convertTime(
                        value.cardFlashTimer,
                        value.device.device_tz,
                        'YYYY-MM-DD HH:mm:ss',
                      ),
                    ).getTime(),
                  ),
                )
                if (duration.minutes() >= 3) {
                  value.cardFlash = false
                }
              }
            } else {
              value.holdValue = true
              value.changeLabel = false
              value.cardFlash = true
              value.rr_last_mint = data.rr_last_mint
              value.lastUpdated = data.rr_last_mint.tracker_ts
              value.cardFlashTimer = data.rr_last_mint.tracker_ts
              value.device.device_conn_status = 1
            }

            value.realTimeRR = data.rr
            value.dist_rr = data.dist_rr
            value.alert10min = data.alert10min
          }
          if (data.action === 'r_score') {
            delete value.rScore
            value.device.device_conn_status = 1
            value.rScore = data.r_score
          }
        }
        if (value.device.device_conn_status === 0) {
          value.dist_rr = null
          value.cardFlash = false
          value.rr_last_mint = {
            avg: null,
            max: null,
            min: null,
            dist_rr_avg: null,
            tracker_ts: '2020-12-03 14:37:48.097365',
          }
        }
        return true
      })
    }
  }
}

export function CLOSE_DB_SOCKET() {
  // channel.close()
  if (socket) {
    socket.close()
  }

  return true
}

// Assigning constant Strings to Saga Functions, in order to access Saga Functions from Redux
export default function* rootSaga() {
  yield all([takeEvery('socket/LISTEN_TO_DB_SOCKET', LISTEN_TO_DB_SOCKET)])
}
